module.exports = __webpack_public_path__ + "img/paragraph.217827c2.svg";